/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useContext } from 'react';

import times from 'lodash/times';

import { Grid, Skeleton } from '@coursera/cds-core';

import IsMobileScreenContext from 'bundles/page/contexts/IsMobileScreenContext';

const CategoryNavigationSkeleton = () => {
  const { isMobileScreen } = useContext(IsMobileScreenContext);

  return (
    <Grid spacing={8} container direction={isMobileScreen ? 'column' : 'row'}>
      {times(isMobileScreen ? 1 : 8, (i) => (
        <Grid item style={{ width: '100%' }} key={`navigation-skeleton-item-${i}`}>
          <Skeleton height="48px" />
        </Grid>
      ))}
    </Grid>
  );
};

export default CategoryNavigationSkeleton;
